// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d__0","fullView":"styles_fullView__DvDLq"};